import React from "react";
import classes from "./index.module.scss";
import { TableWide } from "../../../modules/list-pc";
import { TableDataColumns, TableDataMobile } from "../table-row";
import { TableMobile } from "modules/list-mobile";

const columns = [
  {
    id: `date`,
    label: `Ngày`,
  },
  {
    id: `taxNumber`,
    label: `Số tax`,
  },
  {
    id: `cost`,
    label: `Số tiền phí (đồng)`,
  },
  {
    id: `linkInvoice`,
    label: `Link E-invoice`,
  },
];

export function RigthContentInvoicesList(props: { invoices: any[] }) {
  return (
    <div className={classes.wrapper}>
      <div className={classes.listSection}>
        <TableWide
          columns={columns}
          Rows={TableDataColumns}
          data={props.invoices}
        />
      </div>

      <div className={classes.listSectionMobile}>
        {props.invoices.map((_, index) => (
          <div key={index}>
            <TableMobile Rows={TableDataMobile} data={_} />
          </div>
        ))}
      </div>
    </div>
  );
}
